import axios from 'axios';

// Функция для проверки валидности ID
const isValidUserId = (id) => {
  return id && 
         typeof id === 'string' && 
         id !== "null" && 
         id !== "undefined" && 
         id.trim() !== "";
};

// Улучшенная функция для получения ID пользователя
export const getUserId = () => {
  // Проверяем все возможные хранилища ID
  const userId = localStorage.getItem('user_id');
  const telegramUserId = localStorage.getItem('telegram_user_id');
  
  // Возвращаем первый валидный ID
  if (isValidUserId(userId)) return userId;
  if (isValidUserId(telegramUserId)) return telegramUserId;
  
  // Если в локальных хранилищах нет, пытаемся получить из куки
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.split('=').map(c => c.trim());
    if ((name === 'telegram_user_id' || name === 'user_id') && isValidUserId(value)) {
      return value;
    }
  }
  
  return null;
};

const api = axios.create({
  baseURL: 'https://fftg.farodinprojects.org:3000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Улучшенный интерцептор с надежной проверкой ID
api.interceptors.request.use(config => {
  // Получаем ID из localStorage
  const userId = getUserId();
  
  if (userId) {
    // Добавляем ID в заголовки
    config.headers['X-User-ID'] = userId;
    
    // Инициализируем параметры, если их еще нет
    if (!config.params) {
      config.params = {};
    }
    
    // Добавляем ID в параметры, если не указано иное
    if (!config.params.user_id && !config.skipUserId) {
      config.params.user_id = userId;
    }
  }
  
  // Добавляем текущий год в параметры по умолчанию, если запрос содержит параметр month
  if (config.params && config.params.month !== undefined && config.params.year === undefined) {
    config.params.year = new Date().getFullYear();
  }
  
  // Логируем каждый запрос для отладки
  console.log(`[API] Отправка ${config.method?.toUpperCase() || 'GET'} запроса на ${config.url}`, {
    userId: userId,
    params: config.params,
    hasHeaders: !!config.headers['X-User-ID']
  });
  
  return config;
});

// Добавляем интерцептор для обработки ошибок
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      console.error('[API] Ошибка авторизации:', error.response.data);
      // Можно добавить перенаправление на страницу авторизации или другую логику
    }
    return Promise.reject(error);
  }
);

export default api;